import React from 'react';

const DateRegistrationStats = ({ dateStatsData, isLoading }) => {
  return (
    <div className="mt-10">
      <div className="mb-4">
        <h3 className="text-base font-medium text-gray-700">
          Inscriptions établissements / organisations
        </h3>
      </div>
      <div className="bg-white border border-gray-200 rounded-lg p-6">
        {isLoading ? (
          <div className="flex animate-pulse">
            {[1, 2, 3, 4].map((index) => (
              <div key={index} className="w-1/4">
                <div className="h-4 bg-gray-200 rounded mb-3 w-20"></div>
                <div className="flex items-center gap-2">
                  <div className="h-3 bg-gray-200 rounded w-24"></div>
                  <div className="h-3 bg-gray-200 rounded w-12"></div>
                </div>
              </div>
            ))}
          </div>
        ) : dateStatsData ? (
          <div className="flex">
            {dateStatsData.dates.map((item, index) => (
              <div key={index} className="w-1/4">
                <h4 className="text-base font-semibold text-gray-800 mb-3">{item.date}</h4>
                <div className="flex items-center gap-2">
                  <span className="text-sm text-gray-600">Total personnes</span>
                  <span className="text-base font-medium text-blue-600">
                    {item.people.toLocaleString('fr-CH')}
                  </span>
                </div>
              </div>
            ))}
            <div className="w-1/4">
              <h4 className="text-base font-semibold text-red-500 mb-3">Total</h4>
              <div className="flex items-center gap-2">
                <span className="text-sm text-gray-600">Total personnes</span>
                <span className="text-base font-medium text-red-500">
                  {dateStatsData.total.people.toLocaleString('fr-CH')}
                </span>
              </div>
            </div>
          </div>
        ) : (
          <div className="text-center py-2">Aucune donnée disponible</div>
        )}
      </div>
    </div>
  );
};

export default DateRegistrationStats;
